import { render } from "./Main.vue?vue&type=template&id=88db777e"
const script = {}
script.render = render

export default script